import { render, staticRenderFns } from "./JnutsProgram.vue?vue&type=template&id=1404849a&scoped=true&"
import script from "./JnutsProgram.vue?vue&type=script&lang=js&"
export * from "./JnutsProgram.vue?vue&type=script&lang=js&"
import style0 from "./JnutsProgram.vue?vue&type=style&index=0&id=1404849a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1404849a",
  null
  
)

export default component.exports